module.exports = __webpack_public_path__ + "img/invisible.51f535ea.svg";